// FILE: src/Comman Components/TimezoneDropdown.js (FULLY UPDATED)

import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { fetchTimezones } from '../services/common';

const { Option } = Select;

export default function TimezoneDropdown({ value, onChange }) {
    const [timezones, setTimezones] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchTimezones()
            .then(data => {
                setTimezones(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Select
            showSearch
            value={value}
            onChange={onChange}
            loading={loading}
            placeholder="Select time zone"
            style={{ width: '100%' }}
            className="brand-kit-select"
            popupClassName="brand-kit-select-popup"
            filterOption={(input, option) =>
                option.children.toLowerCase().replace(/_/g, ' ').indexOf(input.toLowerCase()) >= 0
            }
        >
            {timezones.map(tz => (
                <Option key={tz} value={tz}>
                    {tz.replace(/_/g, ' ')}
                </Option>
            ))}
        </Select>
    );
}